import React from 'react'
import ActionButton from '../../../../library/input/buttons/button/SarasButton'

const DocLabelWithSHEditor =(props)=>{
    const {formObject, viewData, reloadSearch} = props;

    // console.log("DocLabelWithSHEditor viewData",viewData);
    const valCssClass = formObject.getValueFromKey(viewData, "dataList.valCssClass", "");

    const onPopupClose = () => {
        if(reloadSearch)reloadSearch();
    }

    const onButtonClick = (e) => {
        let customAction = {actionId:"edit", skipMasterKey: 1, containerKey: "popup"};
        
        //TODO give support for dashboard
        if (!customAction.actionParam) {
            customAction["actionParam"] = {};
        }

        customAction.onModalClose = onPopupClose;
        customAction.actionParam["showModeID"] = "sh";
        customAction.actionParam["dtId"] = viewData.dataList.valLDT;
        customAction.actionParam["dId"] = viewData.val;

        customAction["actionName"] = formObject.getValueFromKey(viewData, "dataList.actionName", "");

        if (customAction.actionId) formObject.onFormAction(customAction, "", "");
    }

    return (
        <div className="saras-cell">
            <div className={valCssClass}>
                <div className="uiLabelWithAction">
                    <span className="uiLWALabel" >
                        <span>{viewData.valF}</span>
                    </span>
                    <span className="uiLWAAction">
                        <ActionButton 
                            onClick={onButtonClick} 
                            tooltip="Quick Edit"
                            onlyIcon={true}
                            starIcon="edit"
                            className="uiLink uiIcon"  />
                    </span>
                </div>
            </div>
        </div>
    )
}

export default DocLabelWithSHEditor